import { useEffect } from 'react';
import { CalibrationSelection, CalibrationCard, CalibrationRuler, ScreenCalibration, CameraCalibration } from '..';
import { usePostMessage } from '../../../context/messageContext';
import CameraCalibrationSelection from './camera-calibration-selection';
import BlindspotCameraCalibration from './blindspot-camera-calibration';
import DeviceCalibration from './device-calibration';
import { useCalibrationSync } from '../../session/calibration/sync';

// Clinician calibration flow (Figma C2-C4.1). Sub-steps:
//   calibration-selection (C2/C4) -> screen-calibration (C3 method) -> device (C3.1/C3.2) | card | ruler
//   calibration-selection -> camera-calibration-selection -> camera-calibration (C4.1) | blindspot-camera-calibration
const TITLES = {
  'camera-calibration-selection': 'Camera Calibration',
  'camera-calibration': 'Camera Calibration',
  'blindspot-camera-calibration': 'Camera Calibration',
};

const Calibration = ({ setTitle, setActiveTab, response, setResponse, calibrationStep, setCalibrationStep }) => {
  const postMessage = usePostMessage();
  const { patchSubStep } = useCalibrationSync();

  useEffect(() => {
    setTitle(TITLES[calibrationStep] || 'Calibration Selection');
  }, [setTitle, calibrationStep]);

  // Lets the patient app and a re-joining clinician land on the same calibration screen.
  useEffect(() => {
    if (calibrationStep) patchSubStep(calibrationStep);
  }, [calibrationStep, patchSubStep]);

  const setStep = (step) => {
    setResponse(null);
    setCalibrationStep(step);
  };

  const renderSwitch = () => {
    switch (calibrationStep) {
      case 'screen-calibration':
        return <ScreenCalibration setStep={setStep} postMessage={postMessage} />;
      case 'device':
        return <DeviceCalibration setStep={setStep} postMessage={postMessage} response={response} />;
      case 'camera-calibration':
        return <CameraCalibration setStep={setStep} postMessage={postMessage} />;
      case 'camera-calibration-selection':
        return <CameraCalibrationSelection setStep={setStep} postMessage={postMessage} />;
      case 'blindspot-camera-calibration':
        return <BlindspotCameraCalibration setStep={setStep} postMessage={postMessage} />;
      case 'calibration-selection':
        return <CalibrationSelection setStep={setStep} postMessage={postMessage} setActiveTab={setActiveTab} />;
      case 'card':
        return <CalibrationCard setStep={setStep} setActiveTab={setActiveTab} postMessage={postMessage} />;
      case 'ruler':
        return <CalibrationRuler setStep={setStep} setActiveTab={setActiveTab} postMessage={postMessage} response={response} />;
      default:
        return <CalibrationSelection setStep={setStep} postMessage={postMessage} setActiveTab={setActiveTab} />;
    }
  };

  return <>{renderSwitch()}</>;
};

export default Calibration;
